import styled from "styled-components";

export const Content = styled.div`
  padding: 0px 0px 0px 0px;
`;
